import React, { useState } from "react";
import { Form } from "semantic-ui-react";
import { useFormik } from "formik";
import { Auth } from "../../../../api";
import { inititalValues, validationSchema } from "./TwoFactorCodeForm.form";
import { useLanguage } from "../../../../contexts";
import { toast } from "react-toastify";

const authController = new Auth();

// Segundo paso del login cuando el usuario tiene 2FA por email activo.
// Reutiliza las clases de LoginForm.scss (login-form, password-input-wrapper,
// recover-password, login-error) porque se renderiza dentro del mismo
// wrapper .login-modal-form — no necesita su propio SCSS.
export function TwoFactorCodeForm({ challengeToken, onVerified, onCancel }) {
  const [error, setError] = useState("");
  const [resending, setResending] = useState(false);
  const { translations } = useLanguage();
  const t = (key) => translations[key] || key;

  const formik = useFormik({
    initialValues: inititalValues(),
    validationSchema: validationSchema(t),
    validateOnChange: false,
    onSubmit: async (formValue) => {
      try {
        const response = await authController.verifyEmailCode({
          challengeToken,
          code: formValue.code,
        });
        onVerified(response.access, response.refresh);
      } catch (error) {
        toast.error(error.msg || t("server_connection_error"));
        setError(error.msg);
      }
    },
  });

  const handleResend = async (e) => {
    e.preventDefault();
    if (resending) return;
    setResending(true);
    try {
      await authController.resendCode({ challengeToken });
      toast.success(t("code_resent"));
    } catch (error) {
      toast.error(error.msg || t("server_connection_error"));
    } finally {
      setResending(false);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter" && !formik.isSubmitting) {
      e.preventDefault();
      formik.handleSubmit();
    }
  };

  return (
    <>
      <p style={{ textAlign: "center", fontWeight: 600, color: "#1a1c40", marginBottom: "0.25rem" }}>
        {t("verify_your_identity")}
      </p>
      <p style={{ textAlign: "center", fontSize: "0.9rem", color: "#666", marginBottom: "1.25rem" }}>
        {t("enter_the_code_sent_to_your_email")}
      </p>

      <Form onSubmit={formik.handleSubmit} className="login-form">
        <Form.Field error={!!formik.errors.code}>
          <div className="password-input-wrapper">
            <i className="lock icon password-input-wrapper__lock" />
            <input
              name="code"
              type="text"
              inputMode="numeric"
              maxLength={6}
              autoComplete="one-time-code"
              placeholder={t("verification_code")}
              onChange={formik.handleChange}
              value={formik.values.code}
              onKeyDown={handleKeyPress}
            />
          </div>
          {formik.errors.code && (
            <div className="ui pointing above prompt label">{formik.errors.code}</div>
          )}
        </Form.Field>

        <Form.Button type="submit" primary fluid size="large" loading={formik.isSubmitting}>
          {t("verify")}
        </Form.Button>

        <a className="recover-password" onClick={handleResend} style={{ opacity: resending ? 0.6 : 1 }}>
          {t("resend_code")}
        </a>
        <a className="recover-password" onClick={onCancel}>
          {t("back_to_login")}
        </a>

        {error && <p className="login-error">{error}</p>}
      </Form>
    </>
  );
}
